import { ModalBlockParts } from '@lib/services';
import { PaymentTermsComponent } from './payment-terms.component';
import { LModalContentsWidthType, ModalType } from '@lib/components';

export interface PaymentTermsPayload {
  message: string;
}

export function paymentTermsModalParts(): ModalBlockParts {
  return {
    id: 'paymentTermsModalParts',
    block: PaymentTermsComponent,
    closeBackEnable: true,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W500,
  };
}
